<ng-container *ngIf="supportSrcSet; else imageWithoutSrcSet">
  <img loading="lazy" draggable="false"
    [ngStyle]="ngStyle"
    [alt]="'alt_' + type"
    [src]="srcImage"
    [srcset]="srcSet"
    (error)="errorHandler()"
    (click)="clickImage.emit()" />
</ng-container>
<ng-template #imageWithoutSrcSet>
  <img loading="lazy" draggable="false"
    [ngStyle]="ngStyle"
    [src]="srcImage"
    [alt]="'alt_' + type"
    (error)="errorHandler()"
    (click)="clickImage.emit()" />
</ng-template>